export default {
  preferredCard: null,
  selectedCard: null,
  isLoading: false,
  // List of cards fetched
  cards: [],
};
